import MuiDialogContent from '@material-ui/core/DialogContent';

export default MuiDialogContent;
